<div class="item-contents">
  <div class="header">
    @switch (item?.type) {
      @case ('Financial Health') {
        <app-outlook-indicator
          class="outlook" size="large"
          [outlookIndicator]="$any(item?.title)"
        ></app-outlook-indicator>
      }
      @case ('Government Type') {
        <div class="tag medium government-type-value">
          {{$any(item?.title)}}
        </div>
      }
      @default {
        <p class="title">{{item?.title}}</p>
      }
    }
    <div class="details">
      @for (field of item?.detailFields; track field) {
        <div class="field" [ngClass]="{'secondary': !field.alwaysDisplay}">
          @if (field.label) {
            <div class="label">{{field.label}}:</div>
          }
          @switch (field.type) {
            @case ('Government Type') {
              <div class="tag small government-type-value">
                {{$any(field.value).description}}
              </div>
            }
            @case ('Outlook Indicator') {
              <app-outlook-indicator
                class="outlook" size="small"
                [outlookIndicator]="$any(field.value)"
              ></app-outlook-indicator>
            }
            @case ('Outlook Indicators') {
              <app-outlook-icon-counts
                size="small"
                [outlookIndicators]="$any(field.value)"
              ></app-outlook-icon-counts>
            }
            @default {
              <div class="value">{{field.value}}</div>
            }
          }
        </div>
      }
    </div>
  </div>
  <div class="type">
    @if (item?.pinned) {
      <svg-icon key="thumbtack-solid"></svg-icon>
    }
    {{item?.type | titlecase}}
  </div>
</div>
@if (!last) {
  <div class="divider">
    <hr>
    </div>
  }
